import Marquee from 'react-fast-marquee';

/**
 * GlobalMarquee — sticky bottom band of label / artist names visible on every
 * page. Sits just above the mini-radio player when active (`hasGlobalPlayer`).
 */
export default function GlobalMarquee({ hasGlobalPlayer = false }) {
  return (
    <div
      className={`fixed left-0 right-0 z-30 bg-gradient-to-r from-yellow-500/15 via-orange-500/15 to-red-500/15 backdrop-blur-md border-t border-white/10 py-2.5 pointer-events-none select-none ${
        hasGlobalPlayer ? 'bottom-[64px]' : 'bottom-0'
      }`}
      data-testid="global-marquee"
    >
      <Marquee speed={45} gradient={false} pauseOnHover={false}>
        <span className="text-base sm:text-lg font-black uppercase tracking-wide text-white/40 mx-6">
          DJHALLMANN • BLACK BOX • PABLO G • KDJOKA • BLACK MACHINE • CORONA • CIRCUMSTANCE • ANNAJAH • REGINA JHEY • MD NO ONE • TRISTREET • MOONJASZ PROJECT • LAROSE • JOELLE URSUL • BANTU BAND • ANDREA SKA • IRINA JAY • SARAH SOUL • HEAVEN • SEWIT • VEE JAY • MARA • FRACA • LIL STE • SALE OR SUGAR • B'O'S (BROTHAS OVER SEAZ) • S'O'S (SISTAS OVER SEAZ) • GUADELOUPE ELECTRO GROOVE • SOUL TRAIN • ANCESTRAL PARTY • KAZAJAH STUDIO •
        </span>
      </Marquee>
    </div>
  );
}
